import { Link } from "react-router-dom";

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 font-display text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-brand-blue ${className}`}
  >
    <span
      className="h-px w-8 bg-gradient-to-r from-navy to-brand-cyan"
      aria-hidden="true"
    />
    {children}
  </span>
);

export const GradientText = ({ children }) => (
  <span className="text-gradient-brand">{children}</span>
);

const primaryCls =
  "inline-flex items-center justify-center gap-2 rounded-[10px] bg-gradient-brand px-7 py-3.5 font-display text-sm font-bold tracking-wide text-white shadow-[0_8px_24px_rgba(0,140,196,0.25)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_34px_rgba(0,140,196,0.38)]";

const secondaryCls =
  "inline-flex items-center justify-center gap-2 rounded-[10px] border border-navy bg-white px-7 py-3.5 font-display text-sm font-bold tracking-wide text-navy transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-cloud";

export const PrimaryButton = ({ to, href, children, className = "", testid, type, disabled }) => {
  if (to && to.startsWith("#"))
    return (
      <a data-testid={testid} href={to} className={`${primaryCls} ${className}`}>
        {children}
      </a>
    );
  if (to)
    return (
      <Link
        data-testid={testid}
        to={to}
        data-track={to === "/contact" ? "free_quote_click" : undefined}
        className={`${primaryCls} ${className}`}
      >
        {children}
      </Link>
    );
  if (href)
    return (
      <a data-testid={testid} href={href} className={`${primaryCls} ${className}`}>
        {children}
      </a>
    );
  return (
    <button data-testid={testid} type={type || "button"} disabled={disabled} className={`${primaryCls} ${className} disabled:opacity-60 disabled:hover:translate-y-0`}>
      {children}
    </button>
  );
};

export const SecondaryButton = ({ to, href, children, className = "", testid }) => {
  if (to)
    return (
      <Link data-testid={testid} to={to} className={`${secondaryCls} ${className}`}>
        {children}
      </Link>
    );
  return (
    <a data-testid={testid} href={href} className={`${secondaryCls} ${className}`}>
      {children}
    </a>
  );
};

export const AirflowCurves = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="flowline" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#053B75" />
        <stop offset="55%" stopColor="#007EBB" />
        <stop offset="100%" stopColor="#18B9CF" />
      </linearGradient>
    </defs>
    <path d="M-10 70 C110 10 260 130 410 55" stroke="url(#flowline)" strokeWidth="1.6" />
    <path d="M-10 115 C130 55 280 175 410 100" stroke="url(#flowline)" strokeWidth="1.6" opacity="0.55" />
    <path d="M-10 160 C150 100 300 220 410 145" stroke="url(#flowline)" strokeWidth="1.6" opacity="0.3" />
  </svg>
);
